import { Box, Header, SpaceBetween } from '@amzn/awsui-components-react'
import headcountSourceLink from '../../reusable/HeadcountSourceLink'
import { ControlExpectedComponent, VarianceComponent } from './SetupHealthUtil'

const SetupHealthTableHeader = (props) => {
    const {
        headerName,
        control,
        expectedGroup,
        varianceGroup,
        expected,
        variance,
        hrPermissionGroup,
        hrPermissionGroupName,
    } = props

    return (
        <Header
            variant='h3'
            actions={
                <SpaceBetween direction='horizontal' size={expectedGroup ? 'm' : 'xxl'}>
                    {expectedGroup && (
                        <>
                            <Box>
                                <Box variant='awsui-key-label'>Control / Group</Box>
                                <ControlExpectedComponent
                                    control={control}
                                    expected={expectedGroup}
                                />
                            </Box>
                            <Box>
                                <Box variant='awsui-key-label'>Group Variance</Box>
                                <VarianceComponent value={varianceGroup} />
                            </Box>
                        </>
                    )}
                    <Box>
                        <Box variant='awsui-key-label'>Control / Team</Box>
                        <ControlExpectedComponent control={control} expected={expected} />
                    </Box>
                    <Box>
                        <Box variant='awsui-key-label'>Team Variance</Box>
                        <VarianceComponent value={variance} />
                    </Box>
                    <Box>
                        <Box variant='awsui-key-label'>Control Source</Box>
                        {headcountSourceLink(hrPermissionGroup, hrPermissionGroupName)}
                    </Box>
                </SpaceBetween>
            }
        >
            {headerName}
        </Header>
    )
}

export default SetupHealthTableHeader
